<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/cross-selling-popup/shared/mini-cart-suggestion/mini-cart-suggestion.component.ts
-->
<ng-template #anchor />
